// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3RGgo","buttons":"RemoveExpirationActionButtons_buttons__3TZLy"};